enum RECORD_PAYMENT_STEP {
  INIT_PAYMENT = 'init_payment', // 组件初始化
  INIT_PAYMENT_CALLBACK = 'init_payment_callback', // 组件初始化回调
  SELECT_COUPON = 'select_coupon', // 选择券
  UPDATE_PAY_METHOD = 'update_pay_method', // (被动)更改支付方式
  CHANGE_PAY_METHOD = 'change_pay_method', // (主动)更改支付方式
  SHOW_PAY_METHOD = 'show_pay_method', // 展示支付方法列表
  GOTO_PAY_PAGE = 'goto_pay_page', // 跳转支付页面
  PAYMENT_CALLBACK = 'payment_callback', // 支付结果回调
  CANCEL_ORDER = 'cancel_order', // 取消订单
  PAYMENT_DOWNGRADE = 'payment_downgrade', // 支付降级
  GOTO_ORDER_STATUS = 'goto_order_status', // 跳转到订单详情页
}

export { RECORD_PAYMENT_STEP }
